import { RuleSet } from 'styled-components';
import React, { ReactNode } from 'react';

export enum ChipsTheme {
  Blue = 'blue',
  White = 'white',
  Dark = 'dark'
}

export interface ChipsProps {
  text: string;
  id?: string;
  icon?: ReactNode | null;
  type?: 'single' | 'checkbox' | 'button';
  name?: string;
  value?: string | number | boolean;
  storedValue?: string | number | boolean | string[];
  style?: React.CSSProperties;
  styles?: RuleSet<object>;
  dirty?: boolean | string | number;
  onClick?: (e?: React.MouseEvent) => void;
  resetHandler?: (e?: React.MouseEvent) => void;
  cypress?: string;
  stat?: string;
  chipsTheme?: ChipsTheme;
  onReset?: () => void;
  iconSize?: number;
  isDark?: boolean;
  iconType?: 'angle' | 'close';
  useDirtyAsActive?: boolean;
  color?: string;
  iconActiveColor?: string;
  iconNeedColorChange?: boolean;
  activeIcon?: ReactNode;
  hasCustomOnChange?: boolean;
  isTextPadding?: boolean;
  borderRadius?: string;
}
